/* ND Reviews carousel */
(function () {
  "use strict";

  const perView = (w) => {
    if (w < 640) return 1;
    if (w < 1024) return 2;
    return 3;
  };

  document.querySelectorAll("[data-rev-carousel]").forEach((root) => {
    const viewport = root.querySelector("[data-rev-viewport]");
    const track = root.querySelector("[data-rev-track]");
    const slides = [...track.querySelectorAll(".rev-slide")];

    if (root.dataset.revLoop === "true") {
      initLoopCarousel(root, track, slides);
      return;
    }

    const prev = root.querySelector("[data-rev-prev]");
    const next = root.querySelector("[data-rev-next]");
    const dotsEl = root.querySelector("[data-rev-dots]");
    const autoplay = root.dataset.autoplay === "true";
    const interval = parseInt(root.dataset.autoplayMs || "6000", 10);

    let index = 0;
    let pv = 3;
    let timer;

    const maxIndex = () => Math.max(0, slides.length - pv);

    const slideStep = () => {
      const gap = parseFloat(getComputedStyle(track).gap) || 19.2;
      const w = viewport.clientWidth;
      return (w - gap * (pv - 1)) / pv + gap;
    };

    const setSlideWidths = () => {
      pv = perView(viewport.clientWidth);
      const gap = parseFloat(getComputedStyle(track).gap) || 19.2;
      const w = viewport.clientWidth;
      const slideW = (w - gap * (pv - 1)) / pv;
      slides.forEach((s) => {
        s.style.width = `${slideW}px`;
      });
      return slideW;
    };

    const renderDots = () => {
      if (!dotsEl) return;
      const pages = maxIndex() + 1;
      dotsEl.innerHTML = "";
      for (let i = 0; i < pages; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", `Go to review page ${i + 1}`);
        if (i === index) b.classList.add("active");
        b.addEventListener("click", () => go(i));
        dotsEl.appendChild(b);
      }
    };

    const go = (i) => {
      index = Math.max(0, Math.min(i, maxIndex()));
      track.style.transform = `translateX(-${index * slideStep()}px)`;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= maxIndex();
      renderDots();
    };

    const tick = () => {
      if (index >= maxIndex()) go(0);
      else go(index + 1);
    };

    const startAutoplay = () => {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(tick, interval);
    };

    const stopAutoplay = () => clearInterval(timer);

    prev?.addEventListener("click", () => go(index - 1));
    next?.addEventListener("click", () => go(index + 1));

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);

    let touchX = 0;
    viewport.addEventListener(
      "touchstart",
      (e) => {
        touchX = e.touches[0].clientX;
        stopAutoplay();
      },
      { passive: true }
    );
    viewport.addEventListener(
      "touchend",
      (e) => {
        const dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
        startAutoplay();
      },
      { passive: true }
    );

    const onResize = () => {
      setSlideWidths();
      go(Math.min(index, maxIndex()));
    };

    setSlideWidths();
    go(0);
    startAutoplay();
    window.addEventListener("resize", onResize);
  });

  function initLoopCarousel(root, track, slides) {
    if (!slides.length) return;

    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const duration = parseInt(root.dataset.revLoopDuration || "48", 10);

    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    });

    track.style.setProperty("--rev-loop-duration", duration + "s");
    root.classList.add("rev-carousel--loop");

    if (reduced) {
      track.style.animation = "none";
      return;
    }

    root.addEventListener("mouseenter", () => track.classList.add("is-paused"));
    root.addEventListener("mouseleave", () => track.classList.remove("is-paused"));
  }
})();
